import { loadSchemaSettings } from "./_actions";
import { SchemaForm } from "./_form";

export const dynamic = "force-dynamic";

export default async function SchemaAdminPage() {
  const settings = await loadSchemaSettings();

  return (
    <div>
      <div className="mb-6">
        <h2 className="font-display font-semibold text-lg mb-1">
          Schema Markup Site-wide
        </h2>
        <p className="text-sm text-ink-muted">
          Cấu hình Organization / Publisher schema áp dụng cho mọi trang. JSON-LD này
          giúp Google Knowledge Graph hiểu site là ai, social media là gì, và format
          rich snippet đúng cách.
        </p>
      </div>

      <SchemaForm settings={settings} />
    </div>
  );
}
